import { useTranslation } from "react-i18next";
import { Product } from "../../types/product";
import { formatCurrency } from "../../utils/format";

interface ProductTableRowProps {
  product: Product;
  onEdit: (product: Product) => void;
  onDeactivate: (product: Product) => void;
}

export const ProductTableRow = ({
  product,
  onEdit,
}: ProductTableRowProps) => {
  const { t } = useTranslation();

  return (
    <tr key={product.code} className="block md:table-row border-b md:border-none">
      <td className="hidden md:table-cell">
        <label>
          <input type="checkbox" className="checkbox" />
        </label>
      </td>
      <td className="block md:table-cell py-3 md:py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-1 md:gap-3">
          {product.logo ? (
            <div className="avatar">
              <div className="w-12 h-12 rounded">
                <img 
                  src={product.logo.medium} 
                  alt={product.name}
                  className="object-cover"
                />
              </div>
            </div>
          ) : (
            <div className="avatar placeholder">
              <div className="w-12 h-12 rounded bg-neutral-focus text-neutral-content">
                <span className="text-xl">
                  {product.name.charAt(0)}
                </span>
              </div>
            </div>
          )}
          <div className="w-full md:w-auto">
            <div className="font-bold">{product.name}</div>
            <div className="text-sm opacity-70">{product.description}</div>
            {/* Show these only on mobile */}
            <div className="text-sm opacity-70 md:hidden mt-1">
              Code: {product.code}
            </div>
            <div className="text-sm opacity-70 md:hidden">
              Price: {formatCurrency(product.price)}
            </div>
            <div className="md:hidden mt-1">
              <span
                className={`badge text-white ${
                  product.status === "ACTIVE" ? "badge-success" : "badge-error"
                }`}
              >
                {product.status}
              </span>
            </div>
          </div>
        </div>
      </td>
      <td className="hidden md:table-cell">{product.code}</td>
      <td className="hidden md:table-cell">
        <span
          className={`badge text-white ${
            product.status === "ACTIVE" ? "badge-success" : "badge-error"
          }`}
        >
          {product.status}
        </span>
      </td>
      <td className="hidden md:table-cell">{formatCurrency(product.price)}</td>
      <td className="block md:table-cell py-2 md:py-4">
        <div className="flex gap-2 justify-end md:justify-start">
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => onEdit(product)}
          >
            {t("products.table.edit")}
          </button>
        </div>
      </td>
    </tr>
  );
};
